/* global $ */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import home from './pages/home.vue'
import plan from './pages/plan.vue'
import contact from './pages/contact.vue'
import checkout from './pages/checkout.vue'

import {
    config
} from 'website-core'

const routes = [{
        path: '',
        component: home,
    },
    {
        path: '/plans',
        component: plan,
    },
    {
        path: '/contact',
        component: contact,
    },
    {
        path: '/checkout/:plan',
        component: checkout,
    },
    // redirect legacy dashboard urls
    {
        path: '/dashboard',
        beforeEnter(to, from, next) {
            window.location = config.url_dashboard
        }
    },
    {
        path: '/dashboard/user',
        beforeEnter(to, from, next) {
            window.location = config.url_dashboard + '/user'
        }
    },
    {
        path: '/dashboard/ip',
        beforeEnter(to, from, next) {
            window.location = config.url_dashboard + '/ip'
        }
    },
    {
        path: '/dashboard/setting',
        beforeEnter(to, from, next) {
            window.location = config.url_dashboard + '/setting'
        }
    },
    {
        path: '/dashboard/billing',
        beforeEnter(to, from, next) {
            window.location = config.url_dashboard + '/billing'
        }
    },
    {
        path: '/dashboard/export',
        beforeEnter(to, from, next) {
            window.location = config.url_dashboard + '/export'
        }
    },
    // 404 redirects to home
    {
        path: "*",
        redirect: '/',
    }
]

const router = new Router({
    mode: 'history',
    routes,
})

export default router